module.exports = __webpack_public_path__ + "static/img/A93.b611d9b9.jpg";